export function getNonNullableObject<T extends Record<string, any>>(
  obj: T,
): { [K in keyof T]: T[K] extends boolean ? boolean : Exclude<T[K], null | undefined> | '' } {
  const newObject = {} as {
    [K in keyof T]: T[K] extends boolean ? boolean : Exclude<T[K], null | undefined> | '';
  };

  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === 'boolean') {
      newObject[key as keyof T] = value as any;
    } else {
      newObject[key as keyof T] = value === null || value === undefined ? '' : value;
    }
  });

  return newObject;
}
